// Author: Shubham Srivastava
// Env File to use for Production.

export const environment = {
  production: true,
  configType: false,
  apiBaseUrl:'https://theworldwidecard.net/api/v1.0/',
  apiBaseUrl2:'https://theworldwidecard.net/api/v1.0',
  apiBaseUrl3:'https://theworldwidecard.net/api',
  setHeaderToken:true
};
